<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <!-- 预支手续费设置 -->
      <Charge ref="charge" />
      <!-- 预付款标准比例设置 -->
      <Prepay ref="prepay" />
      <!-- 油/ETC标准比例设置 -->
      <Oil ref="oil" />
      <!-- 充值油返利给承运司机比例 -->
      <Recharge ref="recharge" />
      <!-- 账期设置 -->
      <Bill ref="bill" />
      <!-- 保费设置 -->
      <Premium ref="premium" />
    </qx-card>
    <SubBtnBox @sub="sub" v-if="checkPermpisions('2000602')" />
  </div>
</template>

<script>
import Charge from './charge';
import Prepay from './prepay';
import Oil from './oil';
import Recharge from './recharge';
import Bill from './bill';
import Premium from './premium';
import SubBtnBox from 'components/subBtnBox';
import {
  driverBenefitsEdit,
  driverBenefits,
} from 'api/system';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    Charge,
    Prepay,
    Oil,
    Recharge,
    Bill,
    Premium,
    SubBtnBox,
  },
  props: {
    carUserType: {
      default: '',
    },
  },
  data () {
    return {
      pageUrl: '/manage/system/risk/driver',
      formComponents: ['charge', 'prepay', 'oil', 'recharge', 'bill', 'premium'],
      editParams: {
        nums: 1,
      },
      isEdit: true,
    };
  },
  computed: {
    detailParams () {
      return {
        carUserType: this.carUserType,
      };
    },
  },
  methods: {
    detailApi: driverBenefits,
    editApi: driverBenefitsEdit,
    handleSubSucc () {
      this.$message.success('保存成功');
    },
  },
  async mounted () {
    this.$refs.bill.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
